export const BUSINESS = {
  name: "Phoenix Plumbing Co.",
  phone: "602-834-1208",
  phoneHref: "tel:+16028341208",
  email: "phoenixazplumbing@gmail.com",
  address: "11801 N Tatum Blvd Suite 88",
  city: "Phoenix",
  state: "AZ",
  zip: "85028",
  lat: 33.593771,
  lng: -111.9784311,
  founded: 2012,
  credentialsLine: "Family-Owned · Serving the Valley Since 2012 · Licensed, Bonded & Insured",
  license: "AZ ROC Licensed, Bonded & Insured",
  url: "https://www.phoenixplumbing.co",
  cid: "16475846041163493395",
  reviewLink:
    "https://search.google.com/local/writereview?placeid=ChIJiXJGrQHiA2ERE3CTga72peQ",
  mapEmbed:
    "https://www.google.com/maps?cid=16475846041163493395&hl=en&output=embed",
  hours: [
    { days: "Mon – Fri", time: "6:00 AM – 5:00 PM" },
    { days: "Saturday", time: "6:00 AM – 2:00 PM" },
    { days: "Sunday", time: "Closed" },
  ],
  afterHoursNote: "After-hours calls and forms answered 24/7.",
  socials: {
    facebook: "https://facebook.com/PhoenixPlumbingCo",
    twitter: "https://twitter.com/PhxPlumbingCo",
    instagram: "https://instagram.com/phoenixplumbingco",
    youtube: "https://youtube.com/@PhoenixPlumbingCo",
    yelp: "https://www.yelp.com/biz/phoenix-plumbing-phoenix-7",
    bbb: "https://www.bbb.org/us/az/phoenix/profile/plumber/phoenix-plumbing-co-1126-1000167142",
  },
};

export const SERVICE_AREA = [
  "Phoenix","Glendale","Scottsdale","Tempe","Mesa","Chandler",
  "Gilbert","Peoria","Surprise","Goodyear","Avondale",
  "Paradise Valley","Cave Creek","Fountain Hills","Sun City","Anthem",
];
